import { defineStore } from 'pinia';
import { ref } from 'vue';
import quotationsAPI from '@/api/quotations';
import type { Quotation } from '@/types/Quotation';

export const useQuotationsStore = defineStore('quotations', () => {
  const quotations = ref<Quotation[]>([]);
  /*const sold_by_user = ref<any>([]);
  const sold_by_medium = ref<any>([]);
  const sold_by_poster = ref<any>([]);
  const sold_by_product = ref<any>([]);
  const quotations_otals = ref<any>([]);*/
  
  const fetchQuotations = async (params: any): Promise<{ data: Quotation[]; total: number }> => {
    try {
      const response = await quotationsAPI.getQuotations(params);
      const data: Quotation[] = response.data.data;
      const total = response.data.meta.total;
      quotations.value = data;
      return { data, total };
    } catch (error) {
      console.error('Error fetching quotation s:', error);
      throw error;
    }
  };

  const fetchQuotationById = async (id: number) => {
    try {
      const response = await quotationsAPI.getQuotationById(id);
      return response.data.data as Quotation;
    } catch (error) {
      console.error(`Error fetching quotation  with ID ${id}:`, error);
    }
  };

  const createQuotation = async (quotationData: Partial<Quotation>) => {
    try {
      const response = await quotationsAPI.createQuotation(quotationData);
      quotations.value.push(response.data.data as Quotation);
      return response.data;
    } catch (error) {
      console.error('Error creating quotation :', error);
    }
  };

  const updateQuotation = async (id: number, quotationData: Partial<Quotation>) => {
    try {
      const response = await quotationsAPI.updateQuotation(id, quotationData);
      const updated = response.data.data as Quotation;
      const index = quotations.value.findIndex((c:any) => c.id === id);
      if (index !== -1) {
        quotations.value[index] = updated;
      }
      return response.data;
    } catch (error) {
      console.error(`Error updating quotation  with ID ${id}:`, error);
    }
  };

  const deleteQuotation = async (id: number) => {
    try {
      await quotationsAPI.deleteQuotation(id);
      quotations.value = quotations.value.filter((c) => c.id !== id);
    } catch (error) {
      console.error(`Error deleting quotation  with ID ${id}:`, error);
    }
  };

  /*
  const soldByUser = async (params: any): Promise<{ data: any; }> => {
    try{
      const response = await quotationsAPI.getSoldByUser(params);
      const data = response.data;
      sold_by_user.value = data
      return data;
    } catch (error){
      throw error;
    }
  };
  const soldByMedium = async (params: any): Promise<{ data: any; }> => {
    try{
      const response = await quotationsAPI.getSoldByMedium(params);
      const data = response.data;
      sold_by_medium.value = data
      return data;
    } catch (error){
      throw error;
    }
  };
  const soldByPoster = async (params: any): Promise<{ data: any; }> => {
    try{
      const response = await quotationsAPI.getSoldByPoster(params);
      const data = response.data;
      sold_by_poster.value = data
      return data;
    } catch (error){
      throw error;
    }
  };
  const soldByProduct = async (params: any): Promise<{ data: any; }> => {
    try{
      const response = await quotationsAPI.getSoldByProduct(params);
      const data = response.data;
      sold_by_product.value = data
      return data;
    } catch (error){
      throw error;
    }
  };
  const quotationsTotals = async (params: any): Promise<{ data: any; }> => {
    try{
      const response = await quotationsAPI.getQuotationsTotals(params);
      const data = response.data;
      quotations_otals.value = data
      return data;
    } catch (error){
      throw error;
    }
  };
  */

  return {
    quotations,
    fetchQuotations,
    fetchQuotationById,
    createQuotation,
    updateQuotation,
    deleteQuotation,
    /*soldByUser,
    soldByMedium,
    soldByPoster,
    soldByProduct,
    quotationsTotals*/
  };
});
